const cache = new Map();
const TTL = 30 * 60 * 1000; // 30 minutes

export const withCache = async (key, fetchFn) => {
    const entry = cache.get(key);
    if (entry && Date.now() - entry.timestamp < TTL) {
        return entry.data;
    }
    const data = await fetchFn();
    cache.set(key, { data, timestamp: Date.now() });
    return data;
};

export const invalidateCache = (...keys) => {
    if (keys.length === 0) {
        cache.clear();
    } else {
        keys.forEach((k) => cache.delete(k));
    }
};
